import React, { Component }  from 'react';
import assets from '../../../helpers/Assets';
import './ErrorView.scss';

class ErrorView extends Component {
  static defaultProps = {
  }

  state = {
  }

  componentWillMount = () => {
  }

  componentDidMount = () => {

  }
  render() {
    const {text} = this.props;
    return (<div className='error_view_container'>
      <img alt='' style={{ width: '2.4rem', height: 'auto' }} src={assets.ERROR}></img>
      <div className='error_view_text'>{text || 'Network load failed. Please try again later.'}</div>
    </div>);
  }
}

export default ErrorView;

